import React from 'react';

/* Atoms */
import { Icon } from "js/components/atoms";
import checkIcon from "symbols/check.svg";
import closeIcon from "symbols/close.svg";

export default function ConversionFlowLeaseUsps({uspsLease}) {
    return (
        <div className="row gutters-1">
            {uspsLease?.usps_lease_title && (
                <div className="col-12 col-lg-auto">
                    <p className=" mb-0 text--14 text--xl-16 font-weight-extra-bold text-base">{uspsLease?.usps_lease_title}</p>
                </div>
            )}
            {uspsLease?.usps_lease?.map((usp, index) => {
                return (
                    <div key={index} className="col-12">
                        <div className="d-flex gap-3">
                            <Icon
                                url={usp.usp_type === 'including' ? checkIcon : closeIcon }
                                size={20}
                                theme={usp.usp_type === 'including' ? 'callout' : 'base' }
                            />

                            <div className="text--14 text--xl-16">
                                <p className=" mb-0 line-height-20">{usp.title}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
